import React from 'react';
import { Music, VolumeX, Volume2, RotateCcw } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function SoundToggle() {
  const { stringsOn, setStringsOn, soundOn, setSoundOn, setTheme } = useTheme();
  return (
    <div className="fixed bottom-5 right-5 z-40 flex items-center gap-1 rounded-full border hairline bg-ink/80 backdrop-blur-xl px-3 py-2 text-xs">
      <Music size={14} className="text-gold" />
      <span className="text-cream/55 hidden sm:inline mr-1">The strings play.</span>
      <button onClick={() => setSoundOn(!soundOn)} className="flex items-center gap-1 px-2 py-1 rounded-full text-cream/80 hover:text-cream transition-colors">
        {soundOn ? <Volume2 size={14} className="text-gold" /> : <VolumeX size={14} />}
        {soundOn ? 'Sound on' : 'Turn sound on'}
      </button>
      <span className="w-px h-4 bg-gold/15" />
      <button onClick={() => setStringsOn(!stringsOn)} className="px-2 py-1 rounded-full text-cream/70 hover:text-cream transition-colors">
        Strings {stringsOn ? 'on' : 'off'}
      </button>
      <button onClick={() => { setStringsOn(true); setSoundOn(false); setTheme('artistic'); }} title="Reset" className="p-1 rounded-full text-cream/60 hover:text-cream transition-colors">
        <RotateCcw size={13} />
      </button>
    </div>
  );
}
